import infoSagas from './info/containers/info-sagas';

export default [...infoSagas];
